import React, { useContext, useEffect, useRef, useState } from 'react';
import { DeleteOutlined, EditOutlined, InfoCircleOutlined, MinusCircleOutlined, PlusOutlined, RollbackOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Card, Col, Divider, Form, Input, Row, Space, Typography, Popconfirm, Table, Modal, InputNumber, DatePicker, Alert, Select, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { dateFormat, menuLinks, notifyMessages, requiredMessages, selectOptionsTypes } from '../../../utils/constants';
import '../customerOrders.scss';
import { usePageTitle } from '../../../context/pageTitleContext';
import NewOrderItem from './newD2COrderItem';
import UpdateOrderItem from './updateOrderItem';
import { useNavigate } from 'react-router';
import DynamicSelect from '../../../components/common/dynamicSelect';
import { useSelector } from 'react-redux';
import { handleDateConvertForApis } from '../../../utils/functions';
import NewD2COrderItem from './newD2COrderItem';
import dayjs from 'dayjs';

const { Text } = Typography;
const { Link } = Typography;

const NewOrderD2C = () => {
    const { t } = useTranslation();
    const salesOrganization = useSelector((state) => state.utils.salesOrganization);
    const { setPageTitle } = usePageTitle();
    const [openCreateDrawer, setOpenCreateDrawer] = useState(false);
    const [openUpdateDrawer, setOpenUpdateDrawer] = useState(false);
    const [orderItems, setOrderItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [loadingSave, setLoadingSave] = useState(false);
    const [orderHadChanges, setOrderHadChanges] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setPageTitle(t('order.singelOrderCreation'));
    }, []);

    const handleSaveOrder = (values) => {
        setOrderHadChanges(false);
        values['orderItems'] = orderItems;
        values.requestedDeliveryDate = handleDateConvertForApis(values.requestedDeliveryDate);

        console.log("valuse", values);

    };

    const confirmSave = (values) => {
        Modal.confirm({
            title: t('messages.noItemsOrderMessage'),
            content: t('messages.orderConfirmationSubmit'),
            okText: t('general.save'),
            cancelText: t('general.cancel'),
            onOk() {
                handleSaveOrder(values);
            }
        });
    };

    const showDrawer = (drawerName, record) => {
        if (drawerName === "create") setOpenCreateDrawer(true);
        if (drawerName === "update") setOpenUpdateDrawer(true); setSelectedItem(record);
    }

    const onCloseDrawer = (drawerName) => {
        if (drawerName === "create") setOpenCreateDrawer(false);
        if (drawerName === "update") setOpenUpdateDrawer(false);
    };

    const addNewItem = (item) => {
        setOrderHadChanges(true);
        const newIndex = orderItems.length;
        item["id"] = newIndex;
        setOrderItems(prevItems => [...prevItems, item]);
    }

    const updateItem = (orderItem) => {
        setOrderHadChanges(true);
        setOrderItems(prevItems =>
            prevItems.map(item =>
                item.id === orderItem.id ? { ...item, ...orderItem } : item
            )
        );
    }

    const onRemoveItem = (itemId) => {
        setOrderItems(prevItems => prevItems.filter(item => item.id !== itemId));
    }

    const columns = [
        {
            title: t('order.item'),
            dataIndex: 'item',
            key: 'item',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.material'),
            dataIndex: 'materialLabel',
            key: 'materialLabel',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.materialType'),
            dataIndex: 'materialTypeLabel',
            key: 'materialTypeLabel',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.orderQuantity'),
            dataIndex: 'orderQuantity',
            key: 'orderQuantity',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.plant'),
            dataIndex: 'plantLabel',
            key: 'plantLabel',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.poDetails'),
            dataIndex: 'poDetails',
            key: 'poDetails',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.shippingPoint'),
            dataIndex: 'shippingPoint',
            key: 'shippingPoint',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.storageLocation'),
            dataIndex: 'storageLocationLabel',
            key: 'storageLocationLabel',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.hlItem'),
            dataIndex: 'hlItem',
            key: 'hlItem',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.poItem'),
            dataIndex: 'poItem',
            key: 'poItem',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            title: t('order.enteredMaterial'),
            dataIndex: 'enteredMaterial',
            key: 'enteredMaterial',
            showSorterTooltip: false,
            ellipsis: true,
        },
        {
            key: "action",
            width: "35px",
            render: (_, record) => {
                return (
                    <Space>
                        <Link onClick={() => showDrawer("update", record)}><EditOutlined className='editIcon' /></Link >
                    </Space>
                )
            }
        },
        {
            key: "action1",
            width: "35px",
            render: (_, record) => {
                return (
                    <Space>
                        <Popconfirm
                            title="Remove item?"
                            onConfirm={() => onRemoveItem(record.id)}
                            okText={t('general.yes')}
                            cancelText={t('general.no')}
                        >
                            <DeleteOutlined className='editIcon' />
                        </Popconfirm>
                    </Space>
                )
            }
        }

    ];

    const onSelectOptionChange = (type, selectedOption) => {
        console.log("type", type)
        console.log("selectedOption", selectedOption)
    }

    return (
        <div className='singelOrder'>

            <NewD2COrderItem open={openCreateDrawer} onClose={() => onCloseDrawer("create")} onNewItemSave={addNewItem} />
            {/* 
            {selectedItem && (
                <UpdateOrderItem open={openUpdateDrawer} onClose={() => onCloseDrawer("update")} recordData={selectedItem} onUpdateOrderItem={updateItem} />
            )} */}

            <Form
                name="newSingelOrder"
                onFinish={orderItems.length > 0 ? handleSaveOrder : confirmSave}
                autoComplete="off"
                layout="vertical"
                className='orderData orderFields'
                size='small'
                onValuesChange={() => { setOrderHadChanges(true) }}
            >
                <Card
                    size="small"
                    className='mb15'
                    title={t('order.order')}
                    extra={
                        <Form.Item style={{ margin: 0 }}>
                            {orderHadChanges && (
                                <Tooltip title={t('messages.orderNotSavedAlert')}><InfoCircleOutlined className='mr10' style={{ color: "red" }} /></Tooltip>
                            )}
                            <Button icon={<SaveOutlined />} style={orderHadChanges && { background: "#742e2e" }} type="primary" htmlType="submit">{t('order.saveOrder')}</Button>
                            <Button size='small' className='ml15' onClick={() => navigate(menuLinks.customerOrders)} icon={<RollbackOutlined />} type="default">{t('order.returnToOrders')}</Button>
                        </Form.Item>
                    }>
                    <Row gutter={[16, 16]}>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.orderNumber')}
                                name="orderNumber"
                                rules={[{ required: true, message: notifyMessages.requiredField }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.orderType')}
                                name="orderType"
                                rules={[{ required: true, message: notifyMessages.requiredField }]}
                            >
                                <DynamicSelect type={selectOptionsTypes.material} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.orderDate')}
                                name="orderDate"
                            >
                                <DatePicker style={{ width: "100%" }} format={dateFormat} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.totalAmount')}
                                name="totalAmount"
                                rules={[{ required: true, message: notifyMessages.requiredField }]}
                            >
                                <InputNumber style={{ width: "100%" }} min={0} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.billToParty')}
                                name="billToParty"
                            >
                                <DynamicSelect type={selectOptionsTypes.billToParty} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.shipTo')}
                                name="shipToParty"
                            >
                                <DynamicSelect type={selectOptionsTypes.shipTo} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>


                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.soldTo')}
                                name="soldToParty"
                            >
                                <DynamicSelect type={selectOptionsTypes.soldTo} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.billingBlock')}
                                name="billingBlock"
                            >
                                <DynamicSelect type={selectOptionsTypes.billingBlock} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.deliveryBlock')}
                                name="deliveryBlock"
                            >
                                <DynamicSelect type={selectOptionsTypes.deliveryBlock} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.division')}
                                name="division"
                            // rules={[{ required: true, message: notifyMessages.requiredField }]}
                            >
                                <DynamicSelect type={selectOptionsTypes.division} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.orderReason')}
                                name="orderReason"
                            >
                                <DynamicSelect type={selectOptionsTypes.orderReason} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.payer')}
                                name="payer"
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.paymentTerms')}
                                name="paymentTerms"
                            >
                                <DynamicSelect type={selectOptionsTypes.paymentTerms} onSelectChange={onSelectOptionChange} />
                            </Form.Item>
                        </Col>


                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.poNumber')}
                                name="poNumber"
                                rules={[
                                    { required: true, message: notifyMessages.requiredField },
                                    // {
                                    //     pattern: /.*\d+$/,
                                    //     message: t('messages.mustEndWithNumbers')
                                    // }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>


                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.quotationNumber')}
                                name="quotationNumber"
                            >
                                <Input />
                            </Form.Item>
                        </Col>


                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.reqDeliveryDate')}
                                name="requestedDeliveryDate"
                                rules={[{ required: true, message: notifyMessages.requiredField }]}

                            >
                                <DatePicker style={{ width: "100%" }} format={dateFormat} />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.salesOrganization')}
                                name="salesOrganization"
                                rules={[{ required: true, message: notifyMessages.requiredField }]}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    placeholder={t('general.select')}
                                    options={salesOrganization.map((item) => ({ value: item.id, label: item.code }))}
                                    onChange={(value, option) => onSelectOptionChange('salesOrganization', option)}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 4 }} >
                            <Form.Item
                                label={t('order.distributionChannel')}
                                name="distributionChannel"
                                rules={[{ required: true, message: notifyMessages.requiredField }]}
                                initialValue={'01'}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                            <Row gutter={[16, 16]}>

                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} >
                                    <Card title={t('order.customerSoldTo')} size='small'>
                                        <Row gutter={[16, 16]}>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.name')}
                                                    name="customerName"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.email')}
                                                    name="customerEmail"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.mobilePhone')}
                                                    name="customerMobilePhone"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.telephone')}
                                                    name="customerTelephone"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.city')}
                                                    name="customerCity"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.region')}
                                                    name="customerRegion"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.postalCode')}
                                                    name="customerPostalCode"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.streetAddress')}
                                                    name="customerStreetAddress"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 1"}
                                                    name="customerTaxNumber1"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 2"}
                                                    name="customerTaxNumber2"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 4"}
                                                    name="customerTaxNumber4"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>

                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} >
                                    <Card title={t('order.shipTo')} size='small'>
                                        <Row gutter={[16, 16]}>
                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.name')}
                                                    name="contactFullName"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.email')}
                                                    name="contactEmail"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.mobile')}
                                                    name="contactMobilePhone"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.telephone')}
                                                    name="contactTelephone"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.city')}
                                                    name="contactCity"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.region')}
                                                    name="contactRegion"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.postalCode')}
                                                    name="contactPostalCode"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.streetAddress')}
                                                    name="contactStreetAddress"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 1"}
                                                    name="contactTaxNumber1"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 2"}
                                                    name="contactTaxNumber2"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} >
                                                <Form.Item
                                                    label={t('order.taxNumber') + " 4"}
                                                    name="contactTaxNumber4"
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>

                <Card size="small" title={t('order.orderItems')} extra={<Button onClick={() => showDrawer("create")} icon={<PlusOutlined />} > {t('order.newItem')} </Button>}>
                    <Row gutter={16}>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                            <Table
                                bordered
                                dataSource={orderItems}
                                columns={columns}
                                size='small'
                                rowKey={obj => obj.id}
                            />
                        </Col>
                    </Row>
                </Card>
            </Form>
        </div>
    );
}
export default NewOrderD2C;